export const useModalManager = defineStore("ModalManager", () => {
  const modals = reactive<Modal[]>([]);
  const queue = ref<Modal[]>([]);

  const openModal = (modalOptions: Modal) => {
    const modal = {
      id: modalOptions.id,
      component: markRaw(modalOptions.component),
      props: modalOptions.props,
    };
    if (modals.length === 0) {
      modals.push(modal);
    } else {
      queue.value.push(modal);
    }
  };

  const closeModal = (modalId: string) => {
    const activeIndex = modals.findIndex((m) => m.id === modalId);
    if (activeIndex !== -1) {
      modals.splice(activeIndex, 1);
    }

    const queuedIndex = queue.value.findIndex((m) => m.id === modalId);
    if (queuedIndex !== -1) {
      queue.value.splice(queuedIndex, 1);
    }

    if (queue.value.length > 0 && modals.length === 0) {
      const nextModal = queue.value.shift();
      if (nextModal) {
        const modal = {
          id: nextModal.id,
          component: markRaw(nextModal.component),
          props: nextModal.props,
        };
        modals.push(modal);
      }
    }
  };

  return {
    modals,
    openModal,
    closeModal,
  };
});
